import React, { useState } from 'react';
import i18next from 'i18next';
import useStyles from "../../../../style/js-style/containers/thirdparties/unmanagedThirdParty/CreateUnmanagedThirdPartyStyle";
import {
  FormGroup,
  FormLabel,
  Grid,
} from '@mui/material';
import { etabType } from '../UnmanagedThirdPartyUtils';
import EAColorIcon from '../../../common/EAColorIcon';
import { UnmanagedInput } from '../UnmanagedInput';

const InputBloc = ({
                     label,
                     placeholder,
                     name,
                     inputType = "input",
                     options = [],
                     isRequired = false,
                     gridSpace = 6,
                     formMethods
                   }) => {
  const { classes } = useStyles();
  const [selectedEtabType, setSelectedEtabType] = useState("headOffice");

  const handleEtabType = (event, value) => {
    setSelectedEtabType(value);
    formMethods.setValue("etabType", value);
  }

  const handleChangeSelect = (target, name) => {
    formMethods.setValue(name, target?.value);
  }

  return (
    <Grid item xs={gridSpace} style={{ padding: "18px 0 0 15px" }}>
      <Grid item xs={12} style={{ marginBottom: "12px" }}>
        <FormLabel className={classes.formLabel}>{label}</FormLabel>
      </Grid>
      <Grid item xs={12}>
        <FormGroup>
          <UnmanagedInput
            options={options}
            placeholder={placeholder}
            name={name}
            inputType={inputType}
            isRequired={isRequired}
            formMethods={formMethods}
            handleChangeSelect={handleChangeSelect}
            selectedEtabType={selectedEtabType}
            handleEtabType={handleEtabType}
          />
        </FormGroup>
      </Grid>
    </Grid>
  );
};

function DeclarationStep({ activity, legalCategory, category, country, formMethods }) {
  const { classes } = useStyles();

  return (
    <>
      {/* Formulaire */}
      <div className={classes.mainContentWrapper}>
        {/* Informations du tiers */}
        <div className={classes.formPartWrapper}>
          <div className={classes.formPartTitle}>
            <EAColorIcon icon={'unmanagedThirdParty/info'} svgStyle={{ position: "relative", top: "2px" }} width={30}/>
            {i18next.t('unmanagedThirdParty.thirdPartyInformations')}
          </div>
          <div className={classes.formPartContent}>
            <div className={classes.formContainer}>
              <Grid container>
                <InputBloc
                  name="socialName"
                  label={i18next.t('unmanagedThirdParty.label.socialName') + " *"}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.socialName')}
                  isRequired
                  inputType={"text"}
                  formMethods={formMethods}
                />

                <InputBloc
                  name="activity"
                  label={i18next.t('unmanagedThirdParty.label.activity') + " *"}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.activity')}
                  inputType={"select"}
                  options={activity}
                  isRequired
                  formMethods={formMethods}
                />

                <InputBloc
                  name="legalCategory"
                  label={i18next.t('unmanagedThirdParty.label.legalCategory')}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.legalCategory')}
                  inputType={"select"}
                  options={legalCategory}
                  formMethods={formMethods}
                />

                <InputBloc
                  name="capital"
                  label={i18next.t('unmanagedThirdParty.label.capital')}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.capital')}
                  inputType={"devise"}
                  formMethods={formMethods}
                />

                <InputBloc
                  name="category"
                  label={i18next.t('unmanagedThirdParty.label.category')}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.category')}
                  inputType={"select"}
                  options={category.map(cat => {
                    return {
                      ...cat,
                      value: cat.value,
                      label: i18next.t(cat.label)
                    }
                  })}
                  formMethods={formMethods}
                />

                <InputBloc
                  name="id_local"
                  label={i18next.t('unmanagedThirdParty.label.id_local')}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.id_local')}
                  inputType={"text"}
                  formMethods={formMethods}
                />

                <InputBloc
                  name="etabType"
                  label={i18next.t('unmanagedThirdParty.label.etabType')}
                  placeholder={i18next.t('unmanagedThirdParty.placeholder.etabType.headOffice')}
                  inputType={"radio"}
                  options={etabType}
                  gridSpace={12}
                  formMethods={formMethods}
                />
              </Grid>
            </div>
          </div>
        </div>

        {/* Séparation */}
        <div className={classes.divider} />

        {/* Coordonnées */}
        <div className={classes.formPartWrapper}>
          <div className={classes.formPartTitle}>
            <EAColorIcon icon={'unmanagedThirdParty/location'} svgStyle={{ position: "relative", top: "3px" }} width={30}/>
            {i18next.t('unmanagedThirdParty.coordinates')}
          </div>
          <div className={classes.formPartContent}>
            <Grid container>
              <InputBloc
                name="country"
                label={i18next.t('unmanagedThirdParty.label.country') + " *"}
                placeholder={i18next.t('unmanagedThirdParty.placeholder.country')}
                inputType={"select"}
                options={country}
                isRequired
                formMethods={formMethods}
              />

              <InputBloc
                name="postalCode"
                label={i18next.t('unmanagedThirdParty.label.postalCode') + " *"}
                placeholder={i18next.t('unmanagedThirdParty.placeholder.postalCode')}
                isRequired
                inputType={"text"}
                formMethods={formMethods}
              />

              <InputBloc
                name="town"
                label={i18next.t('unmanagedThirdParty.label.town') + " *"}
                placeholder={i18next.t('unmanagedThirdParty.placeholder.town')}
                isRequired
                inputType={"text"}
                formMethods={formMethods}
              />

              <InputBloc
                name="address"
                label={i18next.t('unmanagedThirdParty.label.address')}
                placeholder={i18next.t('unmanagedThirdParty.placeholder.address')}
                inputType={"text"}
                formMethods={formMethods}
              />
            </Grid>
          </div>
        </div>
      </div>
    </>
  )
}

export default DeclarationStep;
